import React from 'react'
import logoSC from "../Imagenes/logoSCTKD.webp"
import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const Styles = makeStyles({
  card: {
    width: "90%",
    maxWidth: 360,
    backgroundColor: "rgba(20, 24, 33, 0.75)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: 16,
    padding: 24,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    color: "#ffffff",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  title: {
    color: "#ffffff",
    fontSize: 22,
    fontWeight: 800,
    fontStyle: "italic",
    textTransform: "uppercase",
    letterSpacing: 1,
    textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
  },
  subtitulo: {
    color: "#b3b3b3",
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 16
  },
  logo: {
    width: 100,
    height: "auto",
    objectFit: "contain",
    marginBottom: 16
  },
  fecha: {
    color: "#ffffff",
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8
  },
  hora: {
    color: "#39ff14",
    fontSize: 40,
    fontWeight: 700,
    lineHeight: 1,
    textShadow: "0 0 12px rgba(57, 255, 20, 0.6), 0 0 24px rgba(57, 255, 20, 0.3)",
    marginBottom: 20
  },
  lugar: {
    color: "#ffffff",
    fontSize: 18,
    fontWeight: 700,
    textTransform: "uppercase",
    marginBottom: 4
  },
  direccion: {
    color: "#ffffff",
    fontSize: 15,
    textDecoration: "none"
  },
  hint: {
    color: "#a0aec0",
    fontSize: 12,
    marginBottom: 20
  },
  cerrarBtn: {
    width: "100%",
    padding: "14px 24px",
    borderRadius: 12,
    textTransform: "uppercase",
    fontWeight: 700,
    fontSize: 15,
    color: "#ffffff",
    letterSpacing: 1,
    background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
    border: "1px solid rgba(255, 0, 0, 0.3)",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
    cursor: "pointer",
    transition: "transform 0.2s ease, filter 0.2s ease",
    outline: "none",
    "&:active": {
      transform: "scale(0.98)",
      filter: "brightness(1.2)"
    }
  }
})

const HorariosModal = (props) => {
    const { horario, handleModal } = props
    const classes = Styles()

    let horas = horario.hora_inicio.slice(0, 5)

    return (
        <div className={classes.card}>
            <Typography className={classes.title}>Horario</Typography>
            <Typography className={classes.subtitulo}>{`Fecha ${horario.dia}`}</Typography>

            <img src={logoSC} alt='' className={classes.logo} />

            <Typography className={classes.fecha}>{`21-09-2025`}</Typography>
            <Typography className={classes.hora}>{`${horas} hs.`}</Typography>

            <Typography className={classes.lugar}>{`${horario.lugar.toUpperCase()}`}</Typography>
            <a href={horario.gps} className={classes.direccion}> {`${horario.direccion}`} </a>
            <Typography variant="body1" className={classes.hint}>Toque dirección para activar GPS</Typography>

            <Button className={classes.cerrarBtn} onClick={handleModal}>Cerrar</Button>
        </div>
    );
}

export default HorariosModal;
